// extracted by mini-css-extract-plugin
export default {"cart-wrapper":"Cart_cart-wrapper__ITm+5","cart-item":"Cart_cart-item__32tZw","postage":"Cart_postage__aQh0r"};